module.exports = "<iframe\r\n    width=\"600\"\r\n    height=\"450\"\r\n    frameborder=\"0\" style=\"border:0\"\r\n    src=\"{{GeoAddress}}\" allowfullscreen >\r\n</iframe>"


//////////////////
// WEBPACK FOOTER
// A:/Work/Siti/Volpe2/src/app/components/tngooglemap/tngooglemap.html
// module id = ../../../../../src/app/components/tngooglemap/tngooglemap.html
// module chunks = 1